/* Dubailist CRO theme — theme.js (no dependencies, ~ES2019)
   Motion: IntersectionObserver reveals, Web Animations API (fly-to-cart, bumps),
   CSS transitions for drawers/sheets, View Transitions for page navigation (CSS-only).
   All motion is skipped when the visitor prefers reduced motion. */
(() => {
  'use strict';
  const T = window.theme || { routes: {}, strings: {} };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------------- toast ---------------- */
  const toast = (msg) => {
    const el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
    clearTimeout(el._t); el._t = setTimeout(() => { el.hidden = true; }, 2600);
  };

  /* ---------------- scroll reveal (staggered per batch) ---------------- */
  const motionOn = !reduceMotion && T.motion && 'IntersectionObserver' in window;
  const revealObserver = motionOn
    ? new IntersectionObserver((entries) => {
        let k = 0;
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.style.setProperty('--i', Math.min(k++, 10));
          e.target.classList.add('is-revealed');
          revealObserver.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 })
    : null;
  const initReveal = (root = document) => {
    $$('[data-reveal]:not(.is-revealed)', root).forEach((el) => {
      const r = el.getBoundingClientRect();
      // first paint: anything already on screen shows immediately (no fade on the first view = better LCP)
      if (!revealObserver || (initReveal.first && r.top < window.innerHeight * 0.9 && r.bottom > 0)) el.classList.add('is-revealed');
      else revealObserver.observe(el);
    });
    markLoaded(root); initSplit(root);
  };

  /* ---------------- images: fade/settle in once loaded ---------------- */
  function markLoaded(root = document) {
    $$('.card__media img.card__img-1, .gallery__slide img, .tile img', root).forEach((img) => {
      if (img.classList.contains('is-loaded')) return;
      const done = () => img.classList.add('is-loaded');
      if (img.complete && img.naturalWidth) done(); else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    });
  }

  /* ---------------- split-text headings ---------------- */
  const splitObserver = motionOn ? new IntersectionObserver((ents) => ents.forEach((en) => {
    if (en.isIntersecting) { en.target.classList.add('is-in'); const h = en.target.closest('.section__head'); if (h) h.classList.add('is-in'); splitObserver.unobserve(en.target); }
  }), { threshold: 0.2 }) : null;
  function splitWords(el) {
    let w = 0;
    const walk = (node) => {
      Array.from(node.childNodes).forEach((n) => {
        if (n.nodeType === 3) {
          const parts = n.textContent.split(/(\s+)/); const frag = document.createDocumentFragment();
          parts.forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            const outer = document.createElement('span'); outer.className = 'split-word';
            const inner = document.createElement('span'); inner.textContent = part; inner.style.setProperty('--w', w++);
            outer.appendChild(inner); frag.appendChild(outer);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(el);
  }
  function initSplit(root = document) {
    $$('.hero__title, .collection-hero h1, .section__head h2, .brand-spot__name', root).forEach((el) => {
      if (el.classList.contains('is-split')) return;
      if (!splitObserver) { const h = el.closest('.section__head'); if (h) h.classList.add('is-in'); return; }
      el.setAttribute('aria-label', el.textContent.trim()); splitWords(el); el.classList.add('is-split');
      $$('.split-word', el).forEach((s) => s.setAttribute('aria-hidden', 'true'));
      requestAnimationFrame(() => splitObserver.observe(el));
    });
  }

  /* ---------------- count-up numbers ---------------- */
  const countUp = (el) => {
    const to = parseInt(el.getAttribute('data-count-up'), 10) || 0; if (!motionOn || to < 2) { el.textContent = to.toLocaleString(); return; }
    const t0 = performance.now(), dur = 1100;
    const step = (t) => { const p = Math.min(1, (t - t0) / dur); const e = 1 - Math.pow(1 - p, 4); el.textContent = Math.round(to * e).toLocaleString(); if (p < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  };
  $$('[data-count-up]').forEach(countUp);

  /* ---------------- ripple on tap ---------------- */
  if (!reduceMotion) document.addEventListener('pointerdown', (e) => {
    const b = e.target.closest('.btn, .pill-btn, .card__add, .icon-btn'); if (!b) return;
    const r = b.getBoundingClientRect(), d = Math.max(r.width, r.height);
    const s = document.createElement('span'); s.className = 'ripple';
    Object.assign(s.style, { width: d + 'px', height: d + 'px', left: (e.clientX - r.left - d / 2) + 'px', top: (e.clientY - r.top - d / 2) + 'px' });
    if (getComputedStyle(b).position === 'static') b.style.position = 'relative';
    b.style.overflow = 'hidden'; b.appendChild(s); setTimeout(() => s.remove(), 650);
  });

  /* ---------------- navigation progress bar ---------------- */
  const nav = $('[data-nav-progress]');
  document.addEventListener('click', (e) => {
    if (!nav || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href]'); if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-drawer-open') || a.hasAttribute('data-facet-link') || a.hasAttribute('data-load-more')) return;
    const u = new URL(a.href, location.href); if (u.origin !== location.origin || (u.pathname === location.pathname && u.hash)) return;
    nav.classList.remove('is-active'); void nav.offsetWidth; nav.classList.add('is-active');
  });
  window.addEventListener('pageshow', () => nav && nav.classList.remove('is-active'));

  /* ---------------- hero parallax ---------------- */
  const heroMedia = $('.hero__media');
  if (heroMedia && !reduceMotion && !document.body.classList.contains('no-float')) {
    let raf = 0;
    window.addEventListener('scroll', () => { if (raf) return; raf = requestAnimationFrame(() => { raf = 0; const y = window.scrollY; if (y < 900) heroMedia.style.setProperty('--parallax', (y * 0.12).toFixed(1) + 'px'); }); }, { passive: true });
  }

  /* ---------------- header: shadow + sticky offset ---------------- */
  const header = $('[data-header]');
  const setStickyTop = () => { if (header) document.documentElement.style.setProperty('--sticky-top', header.offsetHeight + 'px'); };
  if (header) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY, sec = header.closest('.header-section');
        header.classList.toggle('is-scrolled', y > 4);
        if (sec && !reduceMotion && !document.body.classList.contains('scroll-lock')) {
          const down = y > (header._lastY || 0) && y > 260;
          sec.classList.toggle('is-hidden', down);
          document.documentElement.style.setProperty('--sticky-top', (down ? 0 : header.offsetHeight) + 'px');
        }
        header._lastY = y; ticking = false;
      });
    }, { passive: true });
    setStickyTop(); window.addEventListener('resize', debounce(setStickyTop, 150));
  }

  /* ---------------- announcement rotator ---------------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar); if (items.length < 2) return;
    let i = 0, paused = false;
    bar.addEventListener('mouseenter', () => { paused = true; }); bar.addEventListener('mouseleave', () => { paused = false; });
    bar.addEventListener('focusin', () => { paused = true; }); bar.addEventListener('focusout', () => { paused = false; });
    setInterval(() => {
      if (paused || document.hidden) return;
      const cur = items[i]; i = (i + 1) % items.length; const next = items[i];
      cur.classList.add('is-leaving'); cur.classList.remove('is-active'); cur.setAttribute('aria-hidden', 'true'); cur.inert = true;
      next.classList.remove('is-leaving'); next.classList.add('is-active'); next.removeAttribute('aria-hidden'); next.inert = false;
      setTimeout(() => cur.classList.remove('is-leaving'), 400);
    }, 4500);
  });

  /* ---------------- drawers (focus trap, esc, scroll lock) ---------------- */
  let lastFocus = null;
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  const openDrawer = (id, opener) => {
    const d = document.getElementById(id); if (!d) return;
    $$('.drawer.is-open').forEach((o) => { if (o !== d) { o.classList.remove('is-open'); o.setAttribute('aria-hidden', 'true'); $$('[aria-controls="' + o.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false')); document.dispatchEvent(new CustomEvent('drawer:close', { detail: { id: o.id } })); } });
    if (!lastFocus || !$('.drawer.is-open')) lastFocus = opener || document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-lock');
    $$('[aria-controls="' + id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    $$('.menu-list > li', d).forEach((li, n) => li.style.setProperty('--n', n));
    document.dispatchEvent(new CustomEvent('drawer:open', { detail: { id } }));
    setTimeout(() => { const f = $('[data-autofocus]', d) || $(FOCUSABLE, $('.drawer__panel', d)); if (f) f.focus({ preventScroll: true }); }, 60);
  };
  const closeDrawer = (d) => {
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('scroll-lock');
    $$('[aria-controls="' + d.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    document.dispatchEvent(new CustomEvent('drawer:close', { detail: { id: d.id } }));
    if (lastFocus && document.contains(lastFocus) && lastFocus.offsetParent !== null) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  };
  window.DL = Object.assign(window.DL || {}, { openDrawer, closeDrawer: (id) => closeDrawer(typeof id === 'string' ? document.getElementById(id) : id), initReveal });
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open'), opener); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    const d = $('.drawer.is-open'); if (!d) return;
    if (e.key === 'Escape') { closeDrawer(d); return; }
    if (e.key === 'Tab') {
      const f = $$(FOCUSABLE, $('.drawer__panel', d)).filter((el) => el.offsetParent !== null && !el.closest('[inert]'));
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------------- cart ---------------- */
  const CART_SECTION = 'cart-drawer';
  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count; el.hidden = count < 1;
      if (!reduceMotion) { el.classList.remove('is-bumping'); void el.offsetWidth; el.classList.add('is-bumping'); }
    });
    $$('[data-cart-label]').forEach((el) => el.setAttribute('aria-label', el.getAttribute('data-cart-label').replace('[count]', count)));
  };
  const renderCartSection = (html) => {
    const drawer = $('#CartDrawer'); if (!drawer || !html) return;
    const doc = parse(html);
    const fresh = $('#CartDrawer', doc) || doc.body.firstElementChild;
    const freshPanel = fresh && $('.drawer__panel', fresh);
    const panel = $('.drawer__panel', drawer);
    if (freshPanel && panel) {
      const fsbOld = $('[data-fsb]', panel);
      const prev = { total: +(panel.dataset.total || 0), saving: +(panel.dataset.saving || 0), count: +(panel.dataset.count || 0), progress: fsbOld ? parseFloat(fsbOld.getAttribute('data-progress')) || 0 : 0, hadLines: !!$('[data-flip-id]', panel) };
      const flipState = (window.Flip && !reduceMotion) ? window.Flip.getState($$('[data-flip-id]', panel)) : null;
      panel.innerHTML = freshPanel.innerHTML;
      ['total', 'saving', 'count'].forEach((k) => { if (freshPanel.dataset[k] !== undefined) panel.dataset[k] = freshPanel.dataset[k]; });
      document.dispatchEvent(new CustomEvent('cart:rendered', { detail: { panel, prev, flipState } }));
      $$('img[loading="lazy"]', panel).forEach((im) => { im.loading = 'eager'; });
      const fill = $('.fsb__fill', panel);
      if (fill && !window.gsap) { const p = fill.style.getPropertyValue('--progress'); fill.style.setProperty('--progress', 0); requestAnimationFrame(() => requestAnimationFrame(() => fill.style.setProperty('--progress', p))); }
    }
    const countEl = $('[data-cart-count-source]', doc);
    if (countEl) updateCount(parseInt(countEl.getAttribute('data-cart-count-source'), 10) || 0);
  };
  const flyToCart = (img) => {
    const target = $('[data-cart-icon]');
    if (!img || !target || reduceMotion || !img.animate) return Promise.resolve();
    const a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width) return Promise.resolve();
    const ghost = img.cloneNode(); ghost.removeAttribute('srcset'); ghost.className = 'fly-ghost';
    Object.assign(ghost.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
    document.body.appendChild(ghost);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const anim = ghost.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: `translate(${dx * 0.6}px, ${dy * 0.4 - 40}px) scale(.5)`, opacity: .9, offset: .6 },
      { transform: `translate(${dx}px, ${dy}px) scale(.08)`, opacity: .2 }
    ], { duration: 650, easing: 'cubic-bezier(.22,.61,.36,1)' });
    return anim.finished.then(() => ghost.remove()).catch(() => ghost.remove());
  };
  const setBtnState = (btn, state) => {
    if (!btn) return;
    btn.classList.remove('is-loading', 'is-done');
    if (state) btn.classList.add(state);
    btn.setAttribute('aria-busy', state === 'is-loading' ? 'true' : 'false');
  };
  const addToCart = async (items, btn, img, openAfter = true) => {
    setBtnState(btn, 'is-loading');
    try {
      const res = await fetch(T.routes.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: [CART_SECTION], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      await flyToCart(img);
      setBtnState(btn, 'is-done');
      setTimeout(() => setBtnState(btn, null), 1400);
      if (data.sections) renderCartSection(data.sections[CART_SECTION]);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (openAfter && $('#CartDrawer')) { closeDrawer($('#QuickAdd')); openDrawer('CartDrawer'); }
      else toast(T.strings.added);
    } catch (err) {
      setBtnState(btn, null);
      toast(err.message || T.strings.error);
    }
  };
  const changeLine = async (key, quantity, lineEl) => {
    if (lineEl && quantity === 0) lineEl.classList.add('is-removing');
    const panel = $('#CartDrawer .drawer__panel'); if (panel) panel.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(T.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: [CART_SECTION, 'main-cart'].filter((s) => s !== 'main-cart' || $('[data-main-cart]')), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || T.strings.error);
      setTimeout(() => {
        if (data.sections) {
          renderCartSection(data.sections[CART_SECTION]);
          if (data.sections['main-cart']) { const m = $('[data-main-cart]'); const f = $('[data-main-cart]', parse(data.sections['main-cart'])); if (m && f) m.innerHTML = f.innerHTML; }
        }
        updateCount(data.item_count);
      }, lineEl && quantity === 0 ? 220 : 0);
    } catch (err) { toast(err.message); if (lineEl) lineEl.classList.remove('is-removing'); }
    finally { if (panel) panel.removeAttribute('aria-busy'); }
  };

  // product forms (PDP, quick-add sheet)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]'); if (!form || !$('#CartDrawer')) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = fd.get('id'); if (!id) { toast(T.strings.chooseSize); return; }
    const btn = e.submitter && e.submitter.closest('.btn') ? e.submitter : $('[type="submit"]', form);
    const scope = form.closest('[data-product]') || document;
    const img = $('[data-fly-src]', scope);
    addToCart([{ id: Number(id), quantity: Number(fd.get('quantity') || 1) }], btn, img);
  });
  // one-tap add (single-variant cards, upsell rows, gap fillers)
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add-variant]'); if (!b) return;
    e.preventDefault();
    const scope = b.closest('[data-card], .upsell-row') || b;
    addToCart([{ id: Number(b.getAttribute('data-add-variant')), quantity: 1 }], b, $('img', scope), !b.closest('#CartDrawer'));
  });
  // quick-add sheet (multi-variant)
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault();
    const sheet = $('#QuickAdd'); if (!sheet) { window.location.href = b.getAttribute('data-quick-add'); return; }
    const body = $('[data-quick-add-body]', sheet);
    body.innerHTML = '<div style="padding:16px"><div class="skeleton" style="height:96px"></div><div class="skeleton" style="height:44px;margin-top:12px"></div><div class="skeleton" style="height:48px;margin-top:12px"></div></div>';
    openDrawer('QuickAdd', b);
    try {
      const url = b.getAttribute('data-quick-add') + (b.getAttribute('data-quick-add').includes('?') ? '&' : '?') + 'section_id=quick-add';
      const html = await (await fetch(url)).text();
      const node = $('[data-quick-add-content]', parse(html));
      body.innerHTML = node ? node.innerHTML : '';
      initProduct(body); markLoaded(body);
    } catch (err) { closeDrawer(sheet); window.location.href = b.getAttribute('data-quick-add'); }
  });
  // cart drawer qty / remove
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      e.preventDefault();
      const line = q.closest('[data-line-key]'); const input = $('input', line);
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(q.getAttribute('data-qty-change'), 10));
      input.value = next; changeLine(line.getAttribute('data-line-key'), next, line); return;
    }
    const r = e.target.closest('[data-line-remove]');
    if (r) { e.preventDefault(); const line = r.closest('[data-line-key]'); changeLine(line.getAttribute('data-line-key'), 0, line); }
  });
  document.addEventListener('change', debounce((e) => {
    const input = e.target.closest('[data-line-key] input[type="number"]'); if (!input) return;
    const line = input.closest('[data-line-key]'); changeLine(line.getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0), line);
  }, 300));
  // copy promo code
  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-copy]'); if (!c) return;
    const text = c.getAttribute('data-copy');
    (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject()).then(() => toast(c.getAttribute('data-copied') || text)).catch(() => {});
  });

  /* ---------------- product page ---------------- */
  const money = (cents, el) => {
    const fmt = (el && el.closest('[data-money-format]') && el.closest('[data-money-format]').getAttribute('data-money-format')) || 'AED {{amount}}';
    const v = (cents / 100).toFixed(2);
    return fmt.replace(/<[^>]*>/g, '').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };
  function initProduct(root) {
    $$('[data-product]', root).forEach((p) => {
      if (p._init) return; p._init = true;
      const dataEl = $('script[data-variants]', p); if (!dataEl) return;
      const variants = JSON.parse(dataEl.textContent);
      const form = $('[data-product-form]', p);
      const idInput = form && $('input[name="id"]', form);
      const lowStock = parseInt(p.getAttribute('data-low-stock') || '3', 10);
      const isMain = p.hasAttribute('data-main-product');
      const selected = () => $$('[data-option-index]', p).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
      const update = () => {
        const opts = selected();
        const hasOptions = $$('[data-option-index]', p).length > 0;
        const v = hasOptions
          ? variants.find((x) => x.options.every((o, i) => o === opts[i]))
          : (variants.find((x) => String(x.id) === String(idInput && idInput.value)) || variants.find((x) => x.available) || variants[0]);
        // availability per option value given other selections
        $$('[data-option-index]', p).forEach((fs) => {
          const idx = parseInt(fs.getAttribute('data-option-index'), 10);
          $$('input', fs).forEach((inp) => {
            const test = opts.slice(); test[idx] = inp.value;
            const match = variants.find((x) => x.options.every((o, i) => test[i] === null || o === test[i]));
            const ok = match && match.available;
            inp.closest('.swatch').classList.toggle('is-unavailable', !ok);
            const small = $('small', inp.closest('.swatch'));
            if (small) small.textContent = (match && match.available && match.qty > 0 && match.qty <= lowStock) ? small.getAttribute('data-template').replace('[count]', match.qty) : '';
          });
          const lbl = $('[data-option-value]', fs); if (lbl) lbl.textContent = opts[idx] || '';
        });
        const btns = $$('[data-add-button]', p);
        if (!v) { btns.forEach((b) => { b.disabled = true; $('.btn__label', b).textContent = opts.some((o) => o === null) ? T.strings.chooseSize : T.strings.unavailable; }); if (idInput) idInput.value = ''; return; }
        if (idInput) idInput.value = v.id;
        btns.forEach((b) => { b.disabled = !v.available; $('.btn__label', b).textContent = v.available ? T.strings.addToCart : T.strings.soldOut; });
        // price block
        $$('[data-price]', p).forEach((el) => {
          const on = v.compare_at_price && v.compare_at_price > v.price;
          el.classList.toggle('price--on-sale', !!on);
          const now = $('.price__now', el), was = $('.price__was', el), save = $('.price__save', el), pct = $('[data-pct]', el);
          if (now) now.textContent = money(v.price, el);
          if (was) { was.textContent = on ? money(v.compare_at_price, el) : ''; was.hidden = !on; }
          if (pct) { pct.hidden = !on; if (on) pct.textContent = '-' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
          if (save) { save.hidden = !on; if (on) save.textContent = save.getAttribute('data-template').replace('[amount]', money(v.compare_at_price - v.price, el)); }
        });
        $$('[data-sticky-price]', p).forEach((el) => { el.textContent = money(v.price, el); });
        $$('[data-sticky-compare]', p).forEach((el) => { const on = v.compare_at_price && v.compare_at_price > v.price; el.hidden = !on; el.textContent = on ? money(v.compare_at_price, el) : ''; });
        $$('[data-sticky-variant]', p).forEach((el) => { el.textContent = v.title === 'Default Title' ? '' : v.title; });
        p.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
        // media
        if (v.media_id) {
          const slide = $('[data-media-id="' + v.media_id + '"]', p);
          if (slide && slide.parentElement) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
        if (isMain && window.history.replaceState) {
          const u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      };
      p.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) update(); });
      update();

      // gallery dots/thumbs
      const track = $('.gallery__track', p);
      if (track) {
        const slides = $$('.gallery__slide', track);
        const marks = $$('[data-goto]', p);
        const setCurrent = (i) => marks.forEach((m) => m.setAttribute('aria-current', String(parseInt(m.getAttribute('data-goto'), 10) === i)));
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > .6) setCurrent(slides.indexOf(en.target)); }), { root: track, threshold: [.6] });
          slides.forEach((s) => io.observe(s));
        }
        marks.forEach((m) => m.addEventListener('click', () => { const s = slides[parseInt(m.getAttribute('data-goto'), 10)]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); }));
      }
      // sticky add to cart
      const sticky = $('[data-sticky-atc]', p), main = $('[data-add-button]', p);
      if (sticky && main && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); }, { threshold: 0 }).observe(main);
      }
    });
  }

  /* ---------------- recommendations (lazy, skeleton → reveal) ---------------- */
  const loadRecs = (el, url) => {
    fetch(url || el.getAttribute('data-url')).then((r) => r.text()).then((html) => {
      const fresh = $('[data-recommendations]', parse(html));
      const tmp = document.createElement('div'); tmp.innerHTML = fresh ? fresh.innerHTML : '';
      // filter: cheaper than the main product, not the current product, limit
      const cap = parseInt(el.getAttribute('data-cheaper-than') || '0', 10);
      const limit = parseInt(el.getAttribute('data-limit') || '0', 10);
      const exclude = el.getAttribute('data-exclude');
      let rows = $$('[data-rec-item]', tmp);
      rows.forEach((r) => { if ((cap && parseInt(r.getAttribute('data-price'), 10) >= cap) || (exclude && r.getAttribute('data-handle') === exclude)) r.remove(); });
      rows = $$('[data-rec-item]', tmp);
      if (limit) rows.slice(limit).forEach((r) => r.remove());
      if ($$('[data-rec-item]', tmp).length) { el.innerHTML = tmp.innerHTML; initReveal(el); }
      else if (el.getAttribute('data-url-fallback')) {
        const list = el.getAttribute('data-url-fallback').split('|').filter(Boolean);
        const next = list.shift(); el.setAttribute('data-url-fallback', list.join('|'));
        if (next) loadRecs(el, next); else el.remove();
      }
      else el.remove();
    }).catch(() => { const l = (el.getAttribute('data-url-fallback') || '').split('|').filter(Boolean); if (l.length) { el.setAttribute('data-url-fallback', l.slice(1).join('|')); loadRecs(el, l[0]); } else el.remove(); });
  };
  if ('IntersectionObserver' in window) {
    const ro = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { ro.unobserve(en.target); loadRecs(en.target); } }), { rootMargin: '400px 0px' });
    $$('[data-recommendations][data-url]').forEach((el) => ro.observe(el));
  } else $$('[data-recommendations][data-url]').forEach(loadRecs);

  /* ---------------- collection: filters + load more ---------------- */
  const results = () => $('[data-results]');
  const swapCollection = async (url, push = true) => {
    const r = results(); if (!r) return;
    r.classList.add('is-loading');
    const u = new URL(url, window.location.origin); u.searchParams.set('section_id', r.getAttribute('data-section'));
    try {
      const doc = parse(await (await fetch(u)).text());
      const flipState = (window.Flip && !reduceMotion) ? window.Flip.getState($$('[data-results] [data-flip-id]')) : null;
      ['[data-results]', '[data-facets]', '[data-active-filters]', '[data-results-count]', '[data-facets-bar]'].forEach((sel) => {
        const fresh = $(sel, doc); $$(sel).forEach((old) => { if (fresh) old.innerHTML = fresh.innerHTML; });
      });
      if (flipState) {
        // cards that stay in the grid glide to their new spot; new cards arrive via the normal reveal
        $$('[data-results] [data-flip-id]').forEach((c) => c.classList.add('is-revealed'));
        window.Flip.from(flipState, { targets: $$('[data-results] [data-flip-id]'), duration: 0.6, ease: 'power3.inOut', absolute: true, scale: true, stagger: 0.015,
          onEnter: (els) => window.gsap.fromTo(els, { opacity: 0, scale: 0.92, y: 16 }, { opacity: 1, scale: 1, y: 0, duration: 0.5, ease: 'expo.out', stagger: 0.03 }) });
      }
      initReveal(results()); $$('[data-count-up]').forEach(countUp);
      if (push) { u.searchParams.delete('section_id'); history.pushState({ collection: true }, '', u.toString()); }
    } finally { const rr = results(); if (rr) rr.classList.remove('is-loading'); }
  };
  document.addEventListener('change', debounce((e) => {
    const form = e.target.closest('[data-facets-form]') || (e.target.form && e.target.form.matches('[data-facets-form]') ? e.target.form : null);
    if (!form) {
      if (e.target.name === 'sort_by' && $('[data-results]')) { const u = new URL(window.location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); swapCollection(u.toString()); }
      return;
    }
    const params = new URLSearchParams(new FormData(form));
    for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
    swapCollection(window.location.pathname + '?' + params.toString());
  }, 350));
  document.addEventListener('submit', (e) => { const form = e.target.closest('[data-facets-form]'); if (form) e.preventDefault(); });
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-facet-link]'); if (!a) return;
    e.preventDefault(); swapCollection(a.href);
  });
  window.addEventListener('popstate', (e) => { if (e.state && e.state.collection) swapCollection(window.location.href, false); });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-load-more]'); if (!b) return;
    e.preventDefault(); b.classList.add('is-loading'); b.disabled = true;
    try {
      const u = new URL(b.getAttribute('href') || b.getAttribute('data-load-more'), window.location.origin);
      u.searchParams.set('section_id', results().getAttribute('data-section'));
      const doc = parse(await (await fetch(u)).text());
      const grid = $('[data-grid]'); const freshCards = $$('[data-grid] > *', doc);
      freshCards.forEach((c) => grid.appendChild(c));
      const freshMore = $('[data-load-more-wrap]', doc), wrap = $('[data-load-more-wrap]');
      if (wrap) wrap.innerHTML = freshMore ? freshMore.innerHTML : '';
      initReveal(grid);
    } catch (err) { window.location.href = b.getAttribute('href'); }
  });

  /* predictive search moved to nextgen.js (search overlay) */

  /* ---------------- init ---------------- */
  initReveal.first = true; initReveal(); initReveal.first = false;
  if (revealObserver) document.documentElement.classList.add('motion-ready');
  document.documentElement.classList.add('img-fx');
  initProduct(document);
  document.addEventListener('shopify:section:load', (e) => { initReveal(e.target); initProduct(e.target); setStickyTop(); });
})();
